import { useState } from "react";

const RecommendedChecks = ({ className = "" }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`bg-white shadow-sm rounded-lg ${className}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between p-4 text-left"
      >
        <div className="flex items-center gap-2">
          <svg className="w-4 h-4 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p className="text-sm font-semibold text-gray-700">Recommended Check Paper</p>
        </div>
        <svg
          className={`w-4 h-4 text-gray-400 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="px-4 pb-4">
          <p className="text-xs text-gray-400 mb-4">These check styles are compatible with PayClear's print layout.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <a
              href={process.env.REACT_APP_AMAZON_SINGLE_CHECK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-4 border border-gray-100 rounded-xl p-4 hover:border-green-400 hover:shadow-sm transition group"
            >
              <div className="w-10 h-10 rounded-lg bg-green-50 text-green-600 flex items-center justify-center flex-shrink-0 group-hover:bg-green-100 transition">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-gray-800 group-hover:text-green-700 transition">Single Check with Stub</p>
                <p className="text-xs text-gray-400 mt-0.5 leading-relaxed">One check per page with a detachable employee summary stub. Best for individual prints.</p>
                <span className="inline-flex items-center gap-1 mt-2 text-xs font-medium text-green-600">
                  View on Amazon
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </span>
              </div>
            </a>
            <a
              href={process.env.REACT_APP_AMAZON_3UP_CHECKS}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-4 border border-gray-100 rounded-xl p-4 hover:border-blue-400 hover:shadow-sm transition group"
            >
              <div className="w-10 h-10 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center flex-shrink-0 group-hover:bg-blue-100 transition">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-gray-800 group-hover:text-blue-700 transition">3-Per-Page Checks</p>
                <p className="text-xs text-gray-400 mt-0.5 leading-relaxed">Three checks per sheet — efficient for high-volume weekly payroll runs.</p>
                <span className="inline-flex items-center gap-1 mt-2 text-xs font-medium text-blue-600">
                  View on Amazon
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </span>
              </div>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecommendedChecks;
